import decorateApolloClient from './decorator';

export default decorateApolloClient;
